<template>
  <div class="orderManagementClass">
    <div class="orderManagementContent" :style="contentViewHeight">
      <div class="printOrderListBox">
        <div>
          <div class="orderSearchBox">
              <el-input
                  v-model="form.productName"
                  placeholder="成果名称"
              ></el-input>
              <el-input
                  v-model="form.creatorName"
                  placeholder="设计师名称"
              ></el-input>
              <el-select v-model="auditStatus" placeholder="状态">
                  <el-option label="全部" value=""> </el-option>
                  <el-option label="待审核" value="REVIEWING"> </el-option>
<!--                  <el-option label="审核通过" value="UNRELEASED"> </el-option>-->
                  <el-option label="审核通过" value="RELEASED"> </el-option>
                  <el-option label="审核拒绝" value="REJECT"> </el-option>
              </el-select>
              <div class="timeSearch">
                  <span style="color: #b2b2b2;">时间</span>
                  <el-date-picker
                      v-model="createDateValue"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="—"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                  >
                  </el-date-picker>
              </div>

              <el-button class="searchBtn" @click="search">搜索</el-button>
              <el-button type="text" class="resetBtn" @click="resetData">
                  <i class="iconfont icon-qingchushujuku"></i>
                  <span>清除条件</span>
              </el-button>
          </div>
          <div class="orderListTable">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              class="tableContent"
            >
            <el-table-column
                prop="designer"
                label="设计师名称"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="成果名称"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="imgs"
                label="缩略图"
                header-align="center"
                align="center"
                show-overflow-tooltip
                width="200"
              >
                <template slot-scope="scope">
                  <img :src="scope.row.imgs" alt="" />
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="workIntroductio"-->
                <!--label="成果简介"-->
                <!--header-align="center"-->
                <!--show-overflow-tooltip-->
                <!--align="center"-->
              <!--&gt;-->
              <!--</el-table-column>-->
              <el-table-column
                prop="upTime"
                label="时间"
                header-align="center"
                show-overflow-tooltip
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="status"
                align="center"
                header-align="center"
                :formatter="showExamineStatus"
                label="状态"
                width="200"
              >
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
                width="230"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status === '待审核'"
                    @click="toDialog(0,scope.row)"
                    >审核</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status != '待审核'"
                    @click="toDialog(1,scope.row)"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handlePageChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!--审核查看弹出框-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <div class="dialogBox">
        <div class="details">
          <div class="detailsItem">
            <h3>成果信息</h3>
            <div class="itemContent">
                <div class="one-row">
                <div class="label">设计师名称:</div>
                <div class="name" v-text="product.creatorName">我是设计师</div>
              </div>
              <div class="one-row">
                <div class="label">成果展示名称:</div>
                <div class="name" v-text="product.productName">某某成果</div>
              </div>
              <div class="two-row">
                <!-- <div class="label">成果缩略图:</div> -->
                <div class="label">成果展示封面:</div>

                <div class="name">
                    <img v-for="(items, index) in product.urlList" :key="index" :src="items.imgUrl" alt="">
                </div>
              </div>
              <div class="one-row" style="width:100%">
                <!-- <div class="label">成果简介:</div> -->
                <div class="label">成果展示详情:</div>
                <div class="name name2 vHtmlMess" v-html="product.remark">这个是成果简介</div>
              </div>

              <div class="two-row">
                <div class="label">时间:</div>
                <div class="name" v-text="product.createDate">2021-11-11</div>
              </div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 1">
          <h3>审核结果</h3>
          <div class="auditContent">
              <el-tag type="success" effect="dark" v-if="product.status == 'UNRELEASED'">审核已通过</el-tag>
              <el-tag type="success" effect="dark" v-if="product.status == 'RELEASED'">审核已通过，并发布</el-tag>
              <el-tag type="danger" effect="dark" v-if="product.status == 'REJECT'">审核已驳回</el-tag>

              <div class="cause" v-if="product.status == 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent">
                {{product.reason}}
              </div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 0">
          <h3>审核</h3>
          <div class="auditContent">
            <el-radio-group v-model="auditForm.status">
              <el-radio label="RELEASED">通过</el-radio>
              <el-radio label="REJECT">驳回</el-radio>
            </el-radio-group>
            <div class="cause" v-if="auditForm.status === 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" style="width: 100%">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                  placeholder="请输入驳回原因"
                  v-model="auditForm.reason"
                >
                </el-input>
              </div>
            </div>
            <div class="auditEnter">
              <el-button type="primary" @click="auditSubmit(product.uuid)">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import {auditProduct, productListByPage} from "../../../utils/interface";
    import {mapState, mapMutations} from "vuex";
export default {
  components: {},
  data() {
    return {
        auditStatus: null,
        createDateValue: null,
        form: {creatorName:'',productName:''},
        auditForm: {},
      typeValue: "",
      modelName: "",
      designerName: "",
      attributeModel:'',
      tableData: [

      ],
      current: 0,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      title: "",
      auditRadio: "",
      textarea: "",
      currentAudit: "",
        product:{},
    };
  },
  computed: {
    contentViewHeight() {
      let height = document.documentElement.clientHeight - 120;
      return { minHeight: height + "px" };
    },
  },
    created() {
        this.search();
    },
  methods: {
      showExamineStatus(row, column){

          if(row.status=="已发布" || row.status=="审核通过"){
              return "审核通过";
          }else if(row.status=="待审核"){
              return "待审核";
          }else if(row.status=="审核驳回"){
              return "审核拒绝";
          }
          // if(row.status=="RELEASED"){
          //     return "审核通过";
          // }else if(row.status=="REVIEWING"){
          //     return "待审核";
          // }else if(row.status=="REJECT"){
          //     return "审核拒绝";
          // }
      },
    resetData() {
      this.form.productName = "";
      this.form.creatorName = "";
      this.auditStatus = null;
      this.createDateValue = null;
        this.form.inputDate = "";
        this.current = 1;
        this.search();
    },
      search(){
          if(this.createDateValue != null){
              this.form.inputDate = this.createDateValue.join(" - ");
          }
          this.form.current = this.current;
          this.form.pageSize = this.pageSize;
          if(this.auditStatus == '' || this.auditStatus == undefined){
              this.form.status = 'NONE';
          }else{
              this.form.status = this.auditStatus;
          }
          this.form.productType = 'PRODUCT';
          productListByPage(this.form).then((res)=>{
              this.tableData = [];
              if(res != null && res.list != null && res.list.length > 0){
                  this.total = res.total;
                  res.list.forEach((item, index) => {
                      let product = {};
                      product.productDetail = item;
                      product.designer = item.creatorName;
                      product.name = item.productName;
                      product.imgs = item.imgUrl;
                      product.workIntroductio = item.remark;
                      product.upTime = item.createDate;
                      product.status = item.statusCn;
                      this.tableData.push(product);
                  });
              }else{
                  this.total = 0;
              }
          });
      },
    // 分页
      handleCurrentChange(val) {
          this.current = val;
      },
      handlePageChange(val) {
          this.current = val;
          this.search();
      },
    // 审核查看
    toDialog(val,product) {
      this.dialogVisible = true;
        this.product = product.productDetail;
      this.currentAudit = val;
      if (val === 0) {
        this.title = "审核详情";
          this.auditForm = {};
      } else {
        this.title = "查看详情";
      }
    },
    // 确定审核
    auditSubmit(uuid) {
      if (this.auditForm.status  === undefined) {
        this.$message.warning("请选择审核结果！");
      } else if (this.auditForm.status  === "REJECT" && this.auditForm.reason  === undefined) {
        this.$message.warning("请输入驳回原因！");
      } else {
          this.auditForm.uuid = uuid;
          auditProduct(this.auditForm).then((res) => {
              if (res) {
                  this.$message.success('审核成功！');
                  this.dialogVisible = false;
                  this.search();
              }
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-tooltip__popper {

 width: 800px;

}
.orderManagementClass {
  position: relative;
  width: 100%;
  padding: 0 20px 20px;
  .orderManagementContent {
    background: #fff;
    .printOrderListBox {
      padding: 20px;
        .orderSearchBox {
            .timeSearch {
                background-color: #f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;

                span {
                    font-size: 12px;
                    color: #c0c4cc !important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }

                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/ input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }

                /deep/ .el-range-input:hover {
                    background-color: #fff !important;
                }

                /deep/ .el-date-editor .el-range-separator {
                    line-height: 25px;
                    color: #c0c4cc;
                }

                /deep/ .el-date-editor .el-range__close-icon {
                    line-height: 28px;
                }

                /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                    background-color: white;
                }

                /deep/ .el-input__inner {
                    width: 225px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    .el-range-input {
                        background-color: #f2f4f7;
                    }

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;

                    }
                }
            }
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

      .tableContent {
        min-height: 600px;

        /deep/ .el-table__header {
          tr {
            th {
              border-right: none;
            }
          }

          /deep/ .el-table__cell {
            padding: 5px 0;
            background: #f2f5fc;
          }
        }

        /deep/ .el-table__body {
          img {
            vertical-align: middle;
            width: 52px;
            height: 50px;
          }
        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;
      }
    }
  }

  //审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;

  }
}

  .dialogBox {
    .details {
      .detailsItem {
        padding-bottom: 20px;
        h3 {
          font-weight: 700;
          font-size: 16px;
          color: #000;
          margin-top: 0;
          letter-spacing: 1px;
          // border-bottom: 1px solid #ddd;
          padding-bottom: 15px;
        }
        .itemContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          // padding: 0 30px;
          .one-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 103px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              // color: #000;
               color: rgba(0, 0, 0, 0.65);
            }
            .name2{
              /deep/img{
                width:100%;
              }
            }
          }
          .two-row {
            width: 100%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              // color: #000;
              color: rgba(0, 0, 0, 0.65);
              img {
                  width: 216px;
              }
            }
          }
        }
        .itemPictureContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          padding: 0 30px;
          justify-content: space-between;
          .one-row {
            width: 30%;
            margin-bottom: 22px;
            img {
              width: 100%;
              height: 138px;
              border: 1px solid #ddd;
            }
            .name {
              text-align: center;
              padding-top: 10px;
              font-size: 14px;
              display: flex;
              .label {
                min-width: 103px;
              }
            }
          }
        }
      }
    }
    .audit {
      padding-bottom: 20px;
      h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 0;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
      }
      .auditContent {
        // padding: 0 30px;
      }
      .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
          min-width: 80px;
          color: #3a8ee6;
        }
        .causeContent {
          color: #000;
        }
      }
      .auditEnter {
        text-align: center;
        padding-top: 20px;
        button {
          width: 120px;
        }
      }
    }
  }
}
</style>
<style>
.el-tooltip__popper{ max-width:50% }
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/designAudit/worksAudit.vue